import { IConfiguration } from './IConfig';

export class ConfigContext {
  config: IConfiguration;
}
